<template>
  <div>
    <a-card style="margin-top:20px;">
      <!--新增 | 维护 MODAL-->
      <create-form ref="createModal" @getTableList="_getTableData" />
      <!-- 结果 -->
      <div class="text-right">
        <a-button @click="toApply" type="primary" class="margin-right-20">
          发起申请
        </a-button>
        <a-button
          @click="_exportAssurance"
          type="primary"
          class="margin-right-20"
        >
          导出excel
        </a-button>
        <a-button @click="$refs.createModal.add()" type="primary" icon="plus">
          新增记录
        </a-button>
      </div>
      <TableView
        ref="table"
        :columns="columns"
        :pagination="pageData"
        :data="tableData"
        :loading="loading"
        :scroll="scroll"
        @handlePagination="handlePagination"
      >
        <!--书面担保金额 writtenAmount -->
        <template v-slot:writtenAmount="{ tableRow }">
          <span>{{ tableRow.writtenAmount | formatAmount }}</span>
        </template>
        <!--货币单位 slot-->
        <template v-slot:currencyUnit="{ tableRow }">
          <span>{{ tableRow.currencyUnit === 1 ? 'RMB' : 'USD' }}</span>
        </template>
        <!--担保金额(元) slot-->
        <template v-slot:validAmount="{ tableRow }">
          <span>{{ tableRow.validAmount | formatAmount }}</span>
        </template>
        <!--操作 slot-->
        <template v-slot:action="{ tableRow }">
          <a
            href="javascript:void(0)"
            :disabled="tableRow.url == '' ? true : false"
          >
            <a-popover title="点击下载" trigger="hover">
              <template slot="content">
                <div v-if="tableRow.attachments.length">
                  <p v-for="item in tableRow.attachments" :key="item.id">
                    <a herf="javascript:;" @click="_downloadAssurance(item.id)">
                      {{ tableRow.attachments.length && item.fileName }}
                    </a>
                  </p>
                </div>
                <a-empty v-else />
              </template>
              <span href="javascript:;" size="small" type="link">
                下载
              </span>
            </a-popover>
          </a>
          <a-divider type="vertical" />
          <a
            v-if="tableRow.type !== 2"
            href="javascript:void(0)"
            @click="$refs.createModal.edit(tableRow)"
            :disabled="tableRow.status == 2 && tableRow.opType == 2"
          >
            编辑
          </a>
          <!-- :disabled="tableRow.status == 2 ? true : false" -->
          <a-divider type="vertical" v-if="tableRow.type !== 2" />
          <a-popconfirm
            title="确定要失效吗?"
            @confirm="() => handleDel(tableRow.id)"
          >
            <a-icon slot="icon" type="question-circle-o" class="icon-color" />
            <a
              href="javascript:void(0)"
              size="small"
              :disabled="tableRow.status == 2 && tableRow.opType == 2"
            >
              失效
            </a>
          </a-popconfirm>
        </template>
      </TableView>
    </a-card>
  </div>
</template>
<script>
import { TableView } from 'lxfintech-fe'
import CreateForm from './components/CreateForm'
import moment from 'moment'
import {
  getAssurance,
  downloadAssurance,
  deleteAssurance,
  getOverview,
  exportAssurance,
} from './api'
import { mapGetters } from 'vuex'
import mixin from './mixin'
export default {
  mixins: [mixin],
  components: {
    TableView,
    CreateForm,
  },
  computed: {
    ...mapGetters('app', ['company']),
    ...mapGetters('user', ['token']),
  },
  data() {
    return {
      loading: '',
      moment,
      scroll: { x: 1500 }, //滚动设置
      formLayout: 'horizontal',
      tableData: [],
      pageData: {
        showTotal: total => `总共 ${total} 条`, //展示总条数
      },
      url: '',
      companyCode: '',
      companyId: this.$route.params.id,
    }
  },
  mounted() {
    this._getTableData()
    this._getOverview()
  },
  methods: {
    async _getOverview() {
      await getOverview(this.companyId).then(({ data }) => {
        this.companyCode = data.code
      })
    },
    toApply() {
      this.$router.push({
        name: 'application',
        query: {
          code: this.companyCode,
        },
      })
    },
    //获取table数据
    async _getTableData() {
      this.loading = true
      const { current, pageSize } = this.pageData
      const query = {
        companyId: this.companyId,
        size: pageSize,
        current,
      }
      try {
        const {
          data: { total, records },
        } = await getAssurance(query)

        this.tableData = records
        this.tableData.map(item => {
          item.efficientDate = this.moment(item.efficientDate).format(
            'YYYY-MM-DD',
          )
          item.expireDate = this.moment(item.expireDate).format('YYYY-MM-DD')
          item.updateTime = this.moment(item.updateTime).format('YYYY-MM-DD')
        })
        this.pageData.total = total
        this.loading = false
      } catch (err) {
        console.log(err)
      }
    },
    //点击查询
    handelSearch(query) {
      this.searchData.name = query.name
      this.searchData.username = query.username
      this.searchData.status = query.status
      this._getTableData()
    },
    //分页
    handlePagination(pagination) {
      ;({
        current: this.pageData.current,
        pageSize: this.pageData.pageSize,
        total: this.pageData.total,
      } = pagination)

      this._getTableData()
    },
    showModal() {
      this.visible = true
    },
    handleCancel() {
      this.visible = false
    }, //抵押和担保下载
    _downloadAssurance(id) {
      try {
        downloadAssurance(id)
      } catch (err) {
        console.log(err)
      }
    },
    async handleDel(id) {
      try {
        await deleteAssurance(id)
        this._getTableData()
      } catch (err) {
        console.log(err)
      }
    },
    //抵押和担保导出excel
    _exportAssurance() {
      try {
        exportAssurance(this.$route.params.id)
      } catch (err) {
        console.log(err)
      }
    },
  },
}
</script>
<style lang="less" scoped>
#components-a-tooltip-demo-placement .ant-btn {
  width: 70px;
  text-align: center;
  padding: 0;
  margin-right: 8px;
  margin-bottom: 8px;
}
</style>
